var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"mb-0"},[_c('v-col',[_c('admin-table',{attrs:{"type":"compute-pending","year":_vm.year,"years":_vm.years,"emails":_vm.emails}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }